import { useInfiniteQuery } from '@tanstack/react-query'
import { useState } from 'react'
import { useParams } from 'react-router-dom'

import { timelineApi } from '@/api/endpoints'
import { keys } from '@/api/keys'
import type { HashtagPage as HashtagPageData, TimelineKind } from '@/api/types'
import { PageHeader } from '@/app/layouts/PageHeader'
import { PostList } from '@/features/posts'
import { KindFilter } from '@/features/timeline'
import { useT } from '@/i18n'

export function HashtagPage() {
  const t = useT()
  const { name = '' } = useParams()
  const [kind, setKind] = useState<TimelineKind>('all')

  const query = useInfiniteQuery({
    queryKey: keys.timelineHashtag(name, kind),
    queryFn: ({ pageParam }) => timelineApi.hashtag(name, pageParam, 20, kind),
    initialPageParam: undefined as string | undefined,
    getNextPageParam: (last: HashtagPageData) => last.next_cursor ?? undefined,
    enabled: Boolean(name),
  })

  const hashtag = query.data?.pages[0]?.hashtag
  const display = hashtag?.display ?? name

  return (
    <>
      <PageHeader
        title={`#${display}`}
        subtitle={hashtag ? t('profile.postCount', { count: hashtag.post_count }) : undefined}
        back
      >
        <div className="px-4 pb-2">
          <KindFilter value={kind} onChange={setKind} />
        </div>
      </PageHeader>
      <PostList
        query={query}
        emptyTitle={t('hashtag.empty', { tag: display })}
        emptyDescription={t('hashtag.emptyBody')}
      />
    </>
  )
}
